"use strict";
(self["webpackChunkbulb_ngclient"] = self["webpackChunkbulb_ngclient"] || []).push([["src_app_page-view-footer_locale_en_json"],{

/***/ 42153:
/***/ ((module) => {

module.exports = JSON.parse('{"likes":{"singular":"Like","plural":"Likes"}}');

/***/ })

}]);